export default "__VITE_ASSET__DoFbRPDB__"